import { FunctionComponent, HTMLAttributes } from "react";
import styles from "./cardGrid.module.css";

export const CardGrid: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => {
  return <div className={styles.cardGrid}>{children}</div>;
};
